import { createAction } from 'typesafe-actions';

import { START_INITIALIZE } from './constants';

export const startInitialize = createAction(START_INITIALIZE)();
